import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeWorkExperience } from "lib/redux/types";
import { TemplateFivePDFSection, TemplateFivePDFSectionWithSubsections } from "./common";

export const WorkExperience = ({
  heading,
  workExperiences,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  workExperiences: ResumeWorkExperience[];
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateFivePDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {workExperiences.map(
        ({ company, jobTitle, startDate, endDate, descriptions }, idx) => {
          // Hide company name if it is the same as the previous company
          const hideCompanyName =
            idx > 0 && company === workExperiences[idx - 1].company;

          return (
            <View
              key={idx}
              style={idx !== 0 ? { marginTop: "12pt" } : {}} // spacing["2"] (24pt) to 12pt
              wrap={false}
            >
              {!hideCompanyName && (
                <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                  {company}
                </ResumePDFText>
              )}
              <View
                style={{
                  ...styles.flexRowBetween,
                  marginTop: hideCompanyName
                    ? "-3pt" // spacing["1"] (12pt) to 3pt
                    : "4pt", // spacing["1.5"] (18pt) to 4pt
                }}
              >
                <ResumePDFText style={{ lineHeight: "1.2" }}>
                  {jobTitle}
                </ResumePDFText>
                <ResumePDFText style={{ lineHeight: "1.2" }}>
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              <View style={{ ...styles.flexCol, marginTop: "3pt" }}> {/* Reduced from spacing["1.5"] (18pt) to 3pt */}
                <ResumePDFDescription 
                  items={descriptions} 
                  enableHighlight={enableHighlight}
                  enableMistakeHighlight={enableMistakeHighlight}
                  section="experience"
                  itemIndex={idx}
                />
              </View>
            </View>
          );
        }
      )}
    </TemplateFivePDFSectionWithSubsections>
  );
};
